// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"56c60ace","61":"b73fa94e","132":"7d3c1f5d","134":"152e669d","259":"4ac03418","334":"bbca4404","453":"a4e47e56","458":"e5a85e4c","787":"f4e192f9"}[chunkId] + ".chunk.js";
};